"use client";

import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../../shadcn";
import { AppButton } from "./app-button";
import { Typography } from "./typography";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonColor?: "red400" | "zinc950";
}

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmButtonColor = "red400"
}: ConfirmationModalProps) => {
  const handleConfirm = async () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent onClick={(e) => e.stopPropagation()} data-testid="confirmation-modal">
        <DialogHeader>
          <DialogTitle data-testid="confirmation-modal-title">
            <Typography variant="heading6" color="zinc900">
              {title}
            </Typography>
          </DialogTitle>
          <DialogDescription data-testid="confirmation-modal-description">
            <Typography variant="body2" color="zinc700">
              {description}
            </Typography>
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <AppButton appearance="outlined" onClick={onClose} data-testid="cancel-button">
            {cancelText}
          </AppButton>
          <AppButton onClick={handleConfirm} color={confirmButtonColor} data-testid="confirm-button">
            {confirmText}
          </AppButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
